import clsx from "clsx";
import { useTranslations } from "translations";

const variantBackgrounds = {
  1: "bg-table-empty-state-variant-1",
  2: "bg-table-empty-state-variant-2",
  3: "bg-table-empty-state-variant-3",
} as const;

const textClasses = "text-center text-heading-xxl text-gray-600";

export type EmptyTableStateProps = {
  variant?: keyof typeof variantBackgrounds;
  firstLine?: string;
  secondLine?: string;
  hideTitle?: boolean;
};

export function EmptyTableState({
  firstLine,
  hideTitle = false,
  secondLine,
  variant = 2,
}: EmptyTableStateProps) {
  const translations = useTranslations();

  const displayFirstLine =
    firstLine ?? translations.predict.dashboard.placeholderNoDataFirstLine;
  const displaySecondLine =
    secondLine ?? translations.predict.dashboard.placeholderNoDataSecondLine;

  return (
    <div className="flex min-h-[400px] max-w-[calc(100vw-64px)] flex-col items-center justify-center">
      <div
        className={clsx(
          "mb-10 h-[170px] w-full bg-contain bg-center bg-no-repeat",
          variantBackgrounds[variant],
        )}
      />
      {!hideTitle && <p className={textClasses}>{displayFirstLine}</p>}
      <p className={textClasses}>{displaySecondLine}</p>
    </div>
  );
}
